import basicsChart from "./basicsChart";

export default {
  components: {basicsChart},
  data() {
    return {};
  },
  props: {
    simpleOptions: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    showLoading() {
      this.$refs.basicsChart && this.$refs.basicsChart.showLoading();
    },
    hideLoading() {
      this.$refs.basicsChart && this.$refs.basicsChart.hideLoading();
    },
    updateChart() {
      this.$refs.basicsChart && this.$refs.basicsChart.updateChart();
    },
    getImg() {
      this.$refs.basicsChart && this.$refs.basicsChart.getImg();
    },
  },
};
